<template>
  <section :class="$style.sectionRoot">
    <header :class="$style.sectionHeader">
      Files
    </header>
    <div :class="$style.sectionContent">
      <div :class="$style.inputRow">
        <table :class="$style.table">
          <thead>
            <tr :class="$style.tableHeader">
              <th>File Name</th>
              <th>File Destination</th>
              <th />
            </tr>
          </thead>
          <tbody :class="$style.tableBody">
            <tr
              v-for="(file, index) in files"
              :key="index"
            >
              <td :class="$style.tableData">
                {{ file.name }}
              </td>
              <td :class="$style.tableData">
                <InputOptionalValidation
                  v-validate="'required'"
                  :errorStyleExceptions="$style.hidden"
                  name="destination"
                  :value="file.destination"
                  @input="(value) => handleDestinationChange(index, value)"
                />
              </td>
              <td :class="$style.deleteContainer">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" :class="$style.deleteIcon" v-bind:svg-inline="''" @click.stop="handleDeleteClick(index)" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill="#54565a" d="M6.303 12.937l1.616 14.24c.087.677 3.353 2.9 8.081 2.903 4.728-.003 7.995-2.226 8.082-2.903l1.616-14.24c-2.469 1.381-6.161 2.036-9.697 2.036s-7.228-.655-9.697-2.036zm14.342-8.8l-1.26-1.397c-.486-.691-1.014-.82-2.041-.82h-2.686c-1.028 0-1.555.129-2.042.82l-1.26 1.397c-3.77.659-6.502 2.406-6.502 3.693v.25c0 2.268 4.991 4.107 11.147 4.107s11.147-1.838 11.147-4.107v-.25c0-1.287-2.732-3.034-6.502-3.693zm-1.61 3.267L17.199 5.44h-2.398l-1.836 1.964h-2.493s2.732-3.256 3.097-3.697a1.12 1.12 0 01.909-.467h.025-.001 3.02c.373 0 .704.183.908.464l.002.003c.364.442 3.097 3.697 3.097 3.697z"/></svg>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div :class="$style.inputRow">
        <FileInput
          buttonText="Upload File"
          :class="$style.uploadButton"
          :handleValueChange="fileUpload"
        />
      </div>
    </div>
  </section>
</template>

<script>
import * as Constants from 'client/util/Constants';
import { ItemTypeConsts, StoreModelMap } from 'client/util/Constants';
import { mapActions, mapState } from 'vuex';
import { notify } from 'client/util';
import FileInput from 'client/components/FormValidation/FileInput.vue';
import InputOptionalValidation from 'client/components/FormValidation/Input.vue';

const commandModel = StoreModelMap[ItemTypeConsts.command];
const { windows } = Constants.default;

export default {
  name: 'CommandDetailsFiles',

  inject: ['$validator'],

  components: {
    FileInput,
    InputOptionalValidation,
  },

  data() {
    return {
      uploadedFiles: [],
    };
  },

  computed: {
    ...mapState(commandModel, [
      'item',
      'files',
    ]),
  },

  methods: {
    ...mapActions(commandModel, [
      'addFile',
      'deleteFile',
      'updateFileDestination',
    ]),

    fileUpload(e) {
      const input = e.target;
      const { files } = input;

      const destinationPath = this.getDefaultDestination();
      files.forEach((file) => {
        const newFile = {
          name: file.name,
          state: 'added',
          destination: destinationPath + file.name,
          content: null,
        };
        this.getFileContent(newFile, file, () => {
          // We only accept files that are 1 MB or smaller right now...
          // Note: If we change this value, we need to make the change in nginx config as well.
          if (file.size <= 1024 * 1024) {
            this.addFile(newFile);
            e.target.value = '';
          } else {
            notify('error', 'File upload supports files 1MB or smaller. Please try again with a smaller file.', $('#messages'), 5 * 1000);
          }
        });
      });
    },

    getDefaultDestination() {
      let dest = 'C:\\Windows\\Temp\\';
      if (this.item.commandType !== windows.toLowerCase()) {
        dest = '/tmp/';
      }
      return dest;
    },

    getFileContent(newFile, file, cb) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const rawContent = e.target.result;
        const base64Content = rawContent.substring(rawContent.indexOf(',') + 1);
        // eslint-disable-next-line
        newFile.content = base64Content;
        cb();
      };
      reader.readAsDataURL(file);
    },

    handleDeleteClick(index) {
      this.deleteFile(index);
    },

    handleDestinationChange(index, value) {
      this.updateFileDestination({ index, value });
    },
  },
};
</script>

<style module>
@import '../../css/flex.css';
@import "../../components/FormValidation/css/formFields.css";
@import '../../css/sections.css';

.deleteContainer {
  line-height: 25px;
  text-align: center;
  vertical-align: bottom;
}

.deleteIcon {
  width: 20px;
}

.hidden { display: none; }

.table {
  width: 100%;
}

.tableBody {
  padding-top: 20px;
}

.tableData {
  max-width: 100px;
  overflow: hidden;
  padding-right: 8px !important;
  text-overflow: ellipsis;
  vertical-align: initial;
  white-space: nowrap;
}

.tableHeader {
  border-bottom: 2px solid #ddd;
  padding-bottom: 20px;
}

.tableHeader th {
  margin-right: 10px;
}

.uploadButton {
  flex: auto;
  margin-top: 20px;
}
</style>
